import VueDag from './VueDag.vue';
export default VueDag;
